import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';
// components
import Page from '../components/Page';
import { motion } from 'framer-motion';
import { varFadeIn } from '../components/animate';

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0)
}));
const BackgroundVideo = styled(motion.video)({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  opacity: 0.3,

});
const HeroOverlayStyle = styled(motion.div)({
  zIndex: 0,
  width: '100%',
  height: '100vh',
  objectFit: 'cover',
  position: 'absolute',
  opacity: '0.8 !important',
});
// ----------------------------------------------------------------------

export default function Page404() {
  return (
    <Page title="404 Page Not Found">
      <Container>
        <ContentStyle sx={{ textAlign: 'center', alignItems: 'center' }}>
          <HeroOverlayStyle alt="overlay" variants={varFadeIn} >
            <BackgroundVideo autoPlay muted loop playsInline>
              <source src="static/background/a-blue-violet-plasma-sphere-on-a-dark-background-free-video.mp4" type="video/mp4" />
              Seu navegador não suporta vídeo.
            </BackgroundVideo>
          </HeroOverlayStyle>



          <Typography variant="h3" paragraph>
            Sorry, page not found!
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>
            Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be
            sure to check your spelling.
          </Typography>

          <Box
            component="img"
            src="/static/illustrations/illustration_404.svg"
            sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 10 } }}
          />

          <Button to="/" size="large" variant="contained" component={RouterLink}>
            Go to Home
          </Button>
        </ContentStyle>
      </Container>
    </Page>
  );
}
